
export const onMouseUp = (props) => {
    // reset all the redux variables because we are "done" dragging/clicking
    props.mouseDown(false);
    props.setStepToCopy(undefined);
    props.setIsDraggingDuration(false);
    props.setStepDataDragging(undefined);
    props.setTransposeDragging(undefined);
    if (props.setSampleExplorerSelected) {
        props.setSampleExplorerSelected(undefined);
    }
}
